module.exports = __webpack_public_path__ + "img/feature_c06.450a5d7a.svg";